<template>
    <bottom-sheet
            title="代付服務統編"
            description="增加代付服務費統編，不包含商品費用"
            @onCancel="onCancel"
            @onConfirm="onConfirm"
            @onClose="onClose">
        <div class="input">
            <input type="text" v-model="vat" @keyup.enter="$event.target.blur()" placeholder="統編" ref="vat">
            <img  v-show="vat" class="btn" @click="vat = ''" src="@/assets/img/cancel.svg">
        </div>
        <div class="error" v-show="error">統編格式錯誤</div>
        <div class="bottom"></div>
    </bottom-sheet>
</template>

<script>
    import BottomSheet from '../BottomSheet';

    export default {
        name: 'SetBehalfFeeVat',
        components: {
            'bottom-sheet': BottomSheet,
        },
        props: {
            defaultVat: {
                default: 0,
            },
            canCancel: {
                default: false,
            }
        },
        data() {
            return {
                vat: '',
                error: '',
            };
        },
        methods: {
            vatVerification(vat) {
                const regex = /^[0-9]{8}$/;
                const logicMultipliers = [1,2,1,2,1,2,4,1];

                const sum = (numbers) => {
                    const initialValue = 0;
                    return numbers.reduce(
                        (accumulator, currentValue) => Number(accumulator) + Number(currentValue),
                        initialValue
                    );
                }

                if (vat && (vat.toString().length !== 8 || !regex.test(vat))) return false;


                let logicProductArr = [];
                let logicProduct = 0;


                for (let i = 0; i < vat.toString().length; i++) {
                    if (i !== 6 || vat[6] !== '7') {
                        logicProductArr.push(parseInt(vat[i]) * logicMultipliers[i]);
                    }
                }

                for (const item of logicProductArr) {
                    logicProduct += sum((item.toString()).split(''))
                }

                if (vat[6] === '7' && (logicProduct % 5 === 0 || (logicProduct + 1) % 5 === 0)) {
                    return true;
                } else if (logicProduct % 5 === 0) {
                    return true;
                }

                return false;
            },
            onConfirm() {
                if (!this.vatVerification(this.vat)) {
                    this.error = true;
                    return;
                }
                this.$emit('onDone', this.vat);
                this.$emit('onClose');
            },
            onClose() {
                this.$emit('onCancel');
            },
            onCancel() {
                this.$emit('onCancel');
            },
        },
        created() {
            if (this.defaultVat) {
                this.vat = this.defaultVat
            }
        }
    };
</script>

<style lang="scss" scoped>
    input {
        border: 1px solid rgba(230,232,237,1);
        border-radius: 4px;
        background-color: rgba(255,255,255,1);
        width: calc(100% - 4px);
        height: 40px;
        text-align: center;
    }

    .cancel {
        border: 1px solid rgba(230,232,237,1);
        border-radius: 4px;
        width: calc(100% - 4px);
        height: 40px;
        text-align: center;
        margin-top: 10px;
        line-height: 40px;
    }

    .input {
        position: relative;
        margin-top: 40px;

        .btn {
            position: absolute;
            top: 0;
            right: 2px;
            height: 26px;
            width: 26px;
            line-height: 20px;
            margin: 10px;
        }
    }

    .error {
        color: #FF7373;
    }

    .bottom {
        margin-bottom: 40px;
    }
</style>
